import React from "react";

export const wsContainer: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  height: "100%",
  background: "white",
  fontFamily: "'Amazon Ember', 'Helvetica Neue', Arial, sans-serif",
};

export const wsBreadcrumb: React.CSSProperties = {
  padding: "12px 24px 0",
  fontSize: "1rem",
  color: "#9ca3af",
  display: "flex",
  alignItems: "center",
  gap: "6px",
  flexShrink: 0,
};

export const wsBreadcrumbLink: React.CSSProperties = {
  background: "none",
  border: "none",
  cursor: "pointer",
  color: "#0f7b8a",
  fontSize: "1rem",
  padding: 0,
};

export const wsBreadcrumbSep: React.CSSProperties = {
  color: "#d1d5db",
};

export const wsHeader: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "12px 24px",
  borderBottom: "1px solid #e5e7eb",
  flexShrink: 0,
};

export const wsHeaderLeft: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: "12px",
  minWidth: 0,
};

export const wsHeaderRight: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: "16px",
  flexShrink: 0,
};

export const wsNavBtn: React.CSSProperties = {
  width: "32px",
  height: "32px",
  borderRadius: "6px",
  background: "#f3f4f6",
  border: "none",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#6b7280",
  fontSize: "1.25rem",
  flexShrink: 0,
};

export const wsTitle: React.CSSProperties = {
  fontSize: "2rem",
  fontWeight: 700,
  color: "#111827",
  margin: 0,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

export const wsCounter: React.CSSProperties = {
  fontSize: "1.25rem",
  color: "#6b7280",
  fontVariantNumeric: "tabular-nums",
};

export const wsBody: React.CSSProperties = {
  flex: 1,
  overflow: "auto",
  padding: "24px",
  display: "grid",
  gridTemplateColumns: "5fr 7fr",
  gap: "16px",
};

export const wsLeftCol: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: "16px",
};

export const wsRightCol: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: "16px",
};

export const wsMediaGrid: React.CSSProperties = {
  display: "grid",
  // One media item per row so each uses the full panel width.
  gridTemplateColumns: "minmax(0, 1fr)",
  gap: "12px",
};

export const wsMediaPlaceholder: React.CSSProperties = {
  background: "#f3f4f6",
  borderRadius: "8px",
  padding: "24px",
  textAlign: "center",
  fontSize: "1.125rem",
  color: "#9ca3af",
};

export const wsMediaImage: React.CSSProperties = {
  width: "100%",
  height: "auto",
  borderRadius: "8px",
  background: "#f3f4f6",
  display: "block",
};

export const wsMediaLink: React.CSSProperties = {
  display: "block",
  width: "100%",
};

export const wsErrorSummary: React.CSSProperties = {
  borderRadius: "8px",
  border: "1px solid #ef4444",
  background: "#fee2e2",
  padding: "16px 20px",
  fontSize: "1rem",
  color: "#991b1b",
};

export const wsProgressTrack: React.CSSProperties = {
  flex: 1,
  height: "10px",
  background: "#f3f4f6",
  borderRadius: "9999px",
  overflow: "hidden",
};

export const wsProgressFill: React.CSSProperties = {
  height: "100%",
  borderRadius: "9999px",
  transition: "width 0.2s",
};

export const wsSuccessBanner: React.CSSProperties = {
  background: "#f0fdf4",
  border: "1px solid #bbf7d0",
  borderRadius: "8px",
  padding: "12px 24px",
  margin: "0 24px 12px",
  color: "#16a34a",
  fontSize: "1rem",
  fontWeight: 600,
  textAlign: "center",
};

export function checklistBtn(
  active: boolean,
  response: "pass" | "fail" | "na",
  disabled: boolean,
): React.CSSProperties {
  const base: React.CSSProperties = {
    padding: "6px 14px",
    borderRadius: "6px",
    fontSize: "1rem",
    fontWeight: 500,
    cursor: disabled ? "not-allowed" : "pointer",
    opacity: disabled ? 0.6 : 1,
    border: "1px solid",
    background: "white",
    borderColor: "#e5e7eb",
    color: "#9ca3af",
  };
  if (!active) return base;
  if (response === "pass")
    return { ...base, background: "#dcfce7", color: "#22c55e", borderColor: "#22c55e" };
  if (response === "fail")
    return { ...base, background: "#fee2e2", color: "#ef4444", borderColor: "#ef4444" };
  return { ...base, background: "#f3f4f6", color: "#4b5563", borderColor: "#6b7280" };
}
